module.exports = __webpack_public_path__ + "img/higher_won.a0388b5f.svg";